import React, { useState } from "react";
import Image from "next/image";

const UspVideoDesk: React.FC = () => {
  const [isPopupOpen, setPopupOpen] = useState({ open: false, code: "" });

  const openPopup = (code: string) => {
    setPopupOpen({ open: true, code: code });
  };

  const closePopup = () => {
    setPopupOpen({ open: false, code: "" });
  };

  return (
    <>
      {/* desktop */}
      <div className="md:block hidden w-full md:pt-[40px] pt-[22px] md:pb-[90px] pb-[32px] justify-center bg-[#0C1F33] relative">
        <Image
          src="/usp/Frame.png"
          alt="Accountants "
          className="cursor-pointer absolute bottom-0 left-0 z-0 md:block hidden"
          width={600}
          height={440}
          loading="lazy"
        />
        <Image
          src="/usp/Group.png"
          alt="Special Offer"
          className="mx-auto absolute md:bottom-0 bottom-0 left-0 w-full z-0 md:hidden block"
          width={360}
          height={327}
          priority
        />
        <div className="mx-auto 2xl:px-0 xl:px-10 lg:p-0 md:block hidden">
          <div className="flex justify-center items-center md:mt-[35px]">
            <div
              className="relative cursor-pointer"
              style={{ width: "960px", height: "539px" }}
              onClick={() => {
                openPopup("QqFAuZzvnDs");
              }}
            >
              <Image
                src="https://ik.imagekit.io/mileseducation/miles_website/home/accountant_shortage.gif"
                alt="Miles US Pathway Roadmap"
                className="mx-auto w-full cursor-pointer"
                width={480}
                height={252}
                priority
              />

              <div className="absolute flex items-center justify-center left-0 right-0 bottom-[32%] md:rounded-[15px] rounded-[15px]">
                <Image
                  src="/images/accounting/usp/video-icon.png"
                  alt="Accountants"
                  className="cursor-pointer w-[50px]"
                  width={110}
                  height={110}
                />
              </div>
            </div>
          </div>
        </div>

        {isPopupOpen.open && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-[1000]">
            <div className="bg-white p-1 shadow-lg relative rounded-[14px] md:w-[auto] w-[85%]">
              <button
                onClick={closePopup}
                className="mt-4 bg-red-700 text-white px-3 py-1 rounded absolute right-[-15px] top-[-30px]"
              >
                ✕
              </button>
              <iframe
                className="lg:w-[600px] md:w-[500px] md:h-[280px] rounded-[14px] lg:h-[320px] h-[220px]"
                width="100%"
                id="huge-shortage-video-player"
                height="320"
                src={`https://www.youtube.com/embed/${isPopupOpen.code}`}
                title="YouTube video player"
                allow="accelerometer; autoplay; climd:oard- pb-14write; encrypted-media; gyroscope; picture-in-picture; web-share"
              ></iframe>
            </div>
          </div>
        )}
      </div>

      {/* mobile */}
      <div className="md:hidden block">
        <div
          className="bg-[#061A2F] p-[15px] relative"
          onClick={() => {
            openPopup("QqFAuZzvnDs");
          }}
        >
          <Image
            src="/images/accounting/usp/global.png"
            alt="Miles US Pathway Roadmap"
            className="mx-auto w-full cursor-pointer"
            width={480}
            height={252}
            priority
          />

          <div className="flex items-center justify-center md:rounded-[15px] rounded-[15px] absolute left-0 right-0 bottom-[32%]">
            <Image
              src="/images/accounting/usp/video-icon.png"
              alt="Accountants "
              className="cursor-pointer w-[50px]"
              width={110}
              height={110}
            />
          </div>
        </div>

        {isPopupOpen.open && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-[999]">
            <div className="bg-white p-1 shadow-lg relative rounded-[14px] md:w-[auto] w-[85%]">
              <button
                onClick={closePopup}
                className="mt-4 bg-red-700 text-white px-3 py-1 rounded absolute right-[-15px] top-[-30px]"
              >
                ✕
              </button>
              <iframe
                className="lg:w-[600px] md:w-[500px] md:h-[280px] rounded-[14px] lg:h-[320px] h-[220px]"
                width="100%"
                height="320"
                src={`https://www.youtube.com/embed/${isPopupOpen.code}`}
                title="YouTube video player"
                allow="accelerometer; autoplay; climd:oard- pb-14write; encrypted-media; gyroscope; picture-in-picture; web-share"
              ></iframe>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default UspVideoDesk;
